module.exports = __webpack_public_path__ + "static/media/banner-conlicitaseg.bf5ae218.png";